import Page from '../../classes/Page'
import { app } from '../../utils/store'

import { getCookie } from '../../utils/cookies'

export default class Utility extends Page{
    constructor(){
        super({
            id : 'utility',
            element: '[data-app-page]',
            elements: { 
                wrapper: 'div[data-wrapper]',
                loader: 'div[data-loader]',
                permission: 'div[data-permission]'
            }
        })

        this.url = new URL(window.location.href)
    }

    create() {
        super.create()

        let permission = getCookie('utility_download') === 'active'
        let force = this.url.searchParams.get('force')

        if(force){ permission = force === 'alsjhdasa' }

        if(this.elements.permission){
            let contents = {
                false: document.querySelectorAll('[data-permission="false"]'),
                true: document.querySelectorAll('[data-permission="true"]'),
            }

            if(!permission){
                contents.false.forEach(entry => entry.style.display = 'block')
                contents.true.forEach(entry => {
                    entry.style.display = 'none'
                    entry.parentNode.removeChild(entry)
                })
            } else {
                contents.false.forEach(entry => {
                    entry.style.display = 'none'
                    entry.parentNode.removeChild(entry)
                })
                contents.true.forEach(entry => entry.style.display = 'block')
            }
        }

        this.elements.loader.style.display = 'none'
        this.elements.wrapper.removeChild(this.elements.loader)
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}